module.exports = "import React from 'react';\nimport DayPicker from 'react-day-picker';\nimport 'react-day-picker/lib/style.css';\n\nexport default function Example() {\n  return (\n    <DayPicker\n      month={new Date(2017, 4, 5)}\n      todayButton=\"Go to Today\"\n      modifiers={{\n        foo: new Date(),\n      }}\n      onTodayButtonClick={(day, modifiers) => console.log(day, modifiers)}\n    />\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/examples/customization-today-button.js
// module id = 766
// module chunks = 168707334958949